// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/finance-calculator-item/finance-calculator-item.component.scss
// module id = 1074
// module chunks = 0